import FincaInvoices from "./FincaInvoices"
import { connect } from "react-redux"
import { clearInvoiceList, getAllInvoicesList } from "../../../redux/actions/finca/fincaInvoices.action"
import { getMissingFincaCustomers } from "../../../redux/actions/finca/missingFincaCustomers.action"
import { showAlertPopup } from "../../../redux/actions/AlertErrorMessage/alertErrorMessage.action"
import { showErrorPopup } from "../../../redux/actions/customErrorPopup/customerrorpopup.action"
import { resetColumnFilters, setColumnFilters, setStatusFilter } from "../../../redux/actions/filters/filter.action"

const mapStateToProps = (state) => {
  return {
    invoiceData: state.fincaInvoicesReducer.data,
    myRights: state.myRights.myRights,
    isLoading: state.fincaInvoicesReducer.isLoading,
    missingFincaCustomers:state?.missingFincaCustomers?.data,
    totalCount:state?.missingFincaCustomers?.totalcount,
    loadingMissingFinca:state?.missingFincaCustomers?.isLoading,
    statusFilter: state?.filtersReducer?.status?.INVOICE,
    columnFilters: state?.filtersReducer?.columnFilters?.INVOICE || {}, 
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getAllInvoicesList: (invoicePeriod) => {
      return dispatch(getAllInvoicesList(invoicePeriod))
    },
    clearInvoiceList:()=>{
      return dispatch(clearInvoiceList())
  },
  getMissingFincaCustomers: () => {
    return dispatch(getMissingFincaCustomers())
  },
  showAlertPopup: (alertHeader,alertmessage) => {
    return dispatch(showAlertPopup(alertHeader,alertmessage))
  },
  showErrorPopup: (errorHeader,errormessage,isnote) => {
    return dispatch(showErrorPopup(errorHeader,errormessage,isnote))
  },
   setStatusFilter: (screen,data) => {
    return dispatch(setStatusFilter(screen, data))
  },
  setColumnFilters: (screen, columnKey, options) =>{
    return dispatch(setColumnFilters(screen, columnKey, options))
  },
  resetColumnFilters: (screen) => {
    return dispatch(resetColumnFilters(screen))
  },
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(FincaInvoices)
